import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { retrieveFromLocalStorage, showErrorMessage, showSuccessMessage } from "../constants";
import {apiEndPoints} from '../remote/apiEndPoints';

const initialState = {
    users: null,
    loading: false,
    error: null,
    isAuthenticated: false,
    ...retrieveFromLocalStorage(["userSession"])
}

const saveToLocalStorage = (key,data)=>{
    localStorage.setItem(key, data);
}

// const saveToLocalStorage = (key, data) => {
//   try {
//       localStorage.setItem(key, JSON.stringify(data));
//   } catch (error) {
//       console.error(`Error saving to localStorage for key "${key}":`, error);
//   }
// }

export const userSignIn = createAsyncThunk(
  "user/signIn",
  async(values) => {
      const signInEndPoint = await apiEndPoints.signIn(values);
      const response = await signInEndPoint.data;
      saveToLocalStorage("userSession", JSON.stringify(response));
      return response;
  }
)

const signOutSession = () =>{
  localStorage.removeItem("users");
  localStorage.removeItem("userSession"); 
}

export const signOut = createAsyncThunk(
  "user/signOut",
  async()=>{
      signOutSession();
  }
)

export const userSignUp = createAsyncThunk(
  "user/signUp",
  async(values) => {
      const signUpEndPoint = await apiEndPoints.signUp(values);
      const response = await signUpEndPoint.data;
      return response;
  }
)

export const generate_token = createAsyncThunk(
  "user/generate_token",
  async(values) => {
      const generateTokenEndPoint = await apiEndPoints.generateToken(values);
      const response = await generateTokenEndPoint.data;
      return response;
  }
)

export const reset_password = createAsyncThunk(
  "user/reset_password",
  async(values) => {
      const resetPasswordEndPoint = await apiEndPoints.resetPassword(values);
      const response = await resetPasswordEndPoint.data;
      return response;
  }
)

export const updatePassword = createAsyncThunk(
  "user/updatePassword",
  async(values) => {
      const updatePasswordEndPoint = await apiEndPoints.updatePassword(values);
      const response = await updatePasswordEndPoint.data;
      return response;
  }
)

export const CampaignCategories = createAsyncThunk(
    "user/campaignCategories",
    async() => {
        const categoryEndPoint = await apiEndPoints.campaignCategories();
        const response = await categoryEndPoint.data;
        // console.log(response)
        return response;
    }
)

export const CampaignList = createAsyncThunk(
  "user/campaignList",
  async() => {
      const campaignListEndPoint = await apiEndPoints.campaignList();
      const response = await campaignListEndPoint.data;
      // console.log(response);
      return response;
  }
)

export const FAQS = createAsyncThunk(
  "user/faqs",
  async() => {
      const faqsEndPoint = await apiEndPoints.faqs();
      const response = await faqsEndPoint.data;
      return response;
  }
)

export const FilterCampaignList = createAsyncThunk(
  "user/filtercampaignList",
  async(categoryID) => {
      const filterCampaignEndPoint = await apiEndPoints.filterCampaignList(categoryID);
      const response = await filterCampaignEndPoint.data;
      return response;
  }
)

export const TotalAmountRaised = createAsyncThunk(
  "user/totalAmountRaised",
  async() => {
    const totalAmountEndPoint = await apiEndPoints.totalAmountRaised();
    const response = await totalAmountEndPoint.data;
    // console.log(response)
    return response;
  }
)

export const CampaignDetails = createAsyncThunk(
  "user/campaignDetails",
  async(campaignReference) => {
      const campaignDetailsEndPoint = await apiEndPoints.campaignDetails(campaignReference);
      const response = await campaignDetailsEndPoint.data;
      // console.log("hello world");
      return response;
  }
)

export const CampaignComments = createAsyncThunk(
  "user/campaignComments",
  async(data) => {
      const campaignCommentsEndPoint = await apiEndPoints.campaignComments(data);
      const response = await campaignCommentsEndPoint.data;
      // console.log(response);
      return response;
  }
)

export const CampaignUpdates = createAsyncThunk(
  "user/campaignUpdates",
  async(campaignReference) => {
      const campaignUpdatesEndPoint = await apiEndPoints.campaignUpdates(campaignReference);
      const response = await campaignUpdatesEndPoint.data;
      // console.log(response)
      return response;
  }
)

export const DonationList = createAsyncThunk(
  "user/donationList",
  async(campaignReference) => {
      const donationListEndPoint = await apiEndPoints.donationList(campaignReference);
      const response = await donationListEndPoint.data;
      // console.log(response)
      return response;
  }
)

export const UserCampaignList = createAsyncThunk(
  "user/campaignList",
  async(email) => {
      const userCampaignListEndPoint = await apiEndPoints.userCampaigns(email);
      const response = await userCampaignListEndPoint.data;
      // console.log(response)
      return response;
  }
)

export const VirtualAccount = createAsyncThunk(
  "user/virtualAccount",
  async(campaignReference) => {
      const virtualAccountEndPoint = await apiEndPoints.virtualAccount(campaignReference);
      const response = await virtualAccountEndPoint.data;
      // console.log(response)
      return response;
  }
)

export const SendComment = createAsyncThunk(
  "user/sendComment",
  async(campaignReference) => {
      const sendCommentEndPoint = await apiEndPoints.sendcampaignComments(campaignReference);
      const response = await sendCommentEndPoint.data;
      // console.log(response)
      return response;
  }
)

export const SendUpdates = createAsyncThunk(
  "user/sendUpdates",
  async(campaignReference) => {
      const sendUpdatesEndPoint = await apiEndPoints.sendcampaignUpdates(campaignReference);
      const response = await sendUpdatesEndPoint.data;
      // console.log(response)
      return response;
  }
)

export const CampaignCreation = createAsyncThunk(
  "user/campaignCreation",
  async(values) => {
      const createCampaignEndPoint = await apiEndPoints.createCampaign(values);
      const response = await createCampaignEndPoint.data;
      // console.log(response)
      return response;
  }
)

export const BankList = createAsyncThunk(
  "user/bankList",
  async() => {
      const bankListEndPoint = await apiEndPoints.bankList();
      const response = await bankListEndPoint.data;
      // console.log(response)
      return response;
  }
)

export const FlutterPayment = createAsyncThunk(
  "user/FlutterwavePayment",
  async(values) => {
      const createFlutterPayment = await apiEndPoints.payWithFlutter(values);
      const response = await createFlutterPayment.data;
      // console.log(response)
      return response;
  }
)


const slice = createSlice ({
  name: "user",
  initialState : initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(userSignIn.fulfilled, (state, action) => {
        if (action.payload.status_code === "0") {
          state.users = action.payload;
          state.isAuthenticated = true;
          state.userSession = action.payload;
        } else {
          state.error = action.payload.message;
          showErrorMessage(action.payload.message);
        }
        state.loading = false;
      })
      .addCase(signOut.fulfilled , (state)=>{
        state.isAuthenticated = false;
        state.loading = false;
        state.users = null;
      })
      .addCase(userSignIn.rejected, (state) => {
        state.loading = false;
        state.users = null;
        state.isAuthenticated = false;
      })
      .addCase(userSignUp.fulfilled, (state, action) => {
        if (action.payload.status_code === "0") {
          state.users = action.payload;
          showSuccessMessage("Registration successful");
          state.userSession = action.payload.user_details; //This isnt necessary right? user still has to confirm account before they are able to sign in
        } else {
          state.error = action.payload.message;
          showErrorMessage(action.payload.message);
        }
        state.loading = false;
      })
      .addCase(userSignUp.rejected, (state) => {
        state.loading = false;
        state.users = null;
        state.isAuthenticated = false;
      })
      .addCase(CampaignCategories.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status_code === "0") {
          state.users = action.payload.result;
        } else {
          state.error = action.payload.message;
          showErrorMessage(action.payload.message);
        }
      })
      .addCase(TotalAmountRaised.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status_code === "0") {
          state.users = action.payload;
        } else {
          state.error = action.payload.message;
          showErrorMessage(action.payload.message);
        }
      })
      .addCase(CampaignDetails.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status_code === "0") {
          state.users = action.payload.result;
          // console.log(action.payload.result);
        } else {
          state.error = action.payload.message;
          showErrorMessage(action.payload.message);
        }
      })
      .addCase(CampaignUpdates.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status_code === "0") {
          state.users = action.payload.result;
        } else {
          state.error = action.payload.message;
          showErrorMessage(action.payload.message);
        }
      })
      .addCase(CampaignComments.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status_code === "0") {
          state.users = action.payload.result;
        } else {
          state.error = action.payload.message;
          showErrorMessage(action.payload.message);
        }
      })
      .addCase(SendComment.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status_code === "0") {
          state.users = action.payload.result;
        } else {
          state.error = action.payload.message;
          showErrorMessage(action.payload.message);
        }
      })
      .addCase(SendUpdates.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status_code === "0") {
          state.users = action.payload.result;
        } else {
          state.error = action.payload.message;
          showErrorMessage(action.payload.message);
        }
      })
      .addCase(DonationList.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status_code === "0") {
          state.users = action.payload.result;
        } else {
          state.error = action.payload.message;
          showErrorMessage(action.payload.message);
        }
      })
      .addCase(VirtualAccount.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status_code === "0") {
          state.users = action.payload.result;
        } else {
          state.error = action.payload.message;
          showErrorMessage(action.payload.message);
        }
      })
      .addCase(CampaignCreation.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status_code === "0") {
          state.users = action.payload.result;
        } else {
          state.error = action.payload.message;
          showErrorMessage(action.payload.message);
        }
      })
      .addCase(FlutterPayment.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status_code === "0") {
          state.users = action.payload.result;
        } else {
          state.error = action.payload.message;
          showErrorMessage(action.payload.message);
        }
      })
      .addCase(BankList.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status_code === "0") {
          state.users = action.payload.result;
        } else {
          state.error = action.payload.message;
          showErrorMessage(action.payload.message);
        }
      })
      .addCase(FAQS.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status_code === "0") {
          state.users = action.payload.result;
        } else {
          state.error = action.payload.message;
          showErrorMessage(action.payload.message);
        }
      })
      
      .addMatcher(
        isAnyOf(
          generate_token.fulfilled,
          reset_password.fulfilled,
          updatePassword.fulfilled,
        ),
        (state, action) => {
          state.loading = false;
          if (action.payload.status_code === "0") {
            state.users = action.payload;
            showSuccessMessage(action.payload.message)
          } else {
            state.error = action.payload.message;
            showErrorMessage(action.payload.message);
          }
        }
      )
      .addMatcher(
        isAnyOf(
          CampaignList.fulfilled,
          FilterCampaignList.fulfilled,
          UserCampaignList.fulfilled
        ),
        (state, action) => {
          state.loading = false;
          if (action.payload.status_code === 0) {
            state.users = action.payload.result;
          } else {
            state.error = action.payload.message;
            showErrorMessage(action.payload.message);
            console.log(action.payload.message);
          }
        }
      )
      .addMatcher(
        isAnyOf(
          CampaignList.pending,
          FilterCampaignList.pending,
          CampaignCategories.pending,
          TotalAmountRaised.pending,
          userSignIn.pending,
          userSignUp.pending,
          CampaignDetails.pending,
          generate_token.pending,
          reset_password.pending,
          updatePassword.pending,
          CampaignComments.pending,
          SendComment.pending,
          CampaignUpdates.pending,
          SendUpdates.pending,
          DonationList.pending,
          VirtualAccount.pending,
          CampaignCreation.pending,
          FlutterPayment.pending,
          FAQS.pending,
          UserCampaignList.pending
        ),
        (state) => {
          state.loading = true;
          state.error = null;
          state.users = null;
        }
      )
      .addMatcher(
        isAnyOf(
          CampaignList.rejected,
          FilterCampaignList.rejected,
          CampaignCategories.rejected,
          TotalAmountRaised.rejected,
          userSignUp.rejected,
          CampaignDetails.rejected,
          generate_token.rejected,
          reset_password.rejected,
          updatePassword.rejected,
          CampaignComments.rejected,
          SendComment.rejected,
          CampaignUpdates.rejected,
          SendUpdates.rejected,
          DonationList.rejected,
          VirtualAccount.rejected,
          CampaignCreation.rejected,
          FlutterPayment.rejected,
          FAQS.rejected,
          UserCampaignList.rejected
        ),
        (state, action) => {
          state.loading = false;
          state.error = showErrorMessage(action.error.message);
          state.users = null;
        }
      );
  }
})

export const userReducer = slice.reducer;